module.exports = __webpack_public_path__ + "fonts/SourceHanSansCN-Regular.b26d46b5.ttf";